import type { DataLayerProps } from 'traveler/src/components/DataLayer';
import { ratPropsToParams } from '../../constants/ratAnalytics';
import type { RatObject } from '../../types/analytics';
import type { AnalyticParams as RatProps } from '.';

export type PropMap = {
  id: string;
  prop: keyof DataLayerProps;
  value?: string;
};

type RatParamsMap = {
  conversion: PropMap[];
  custom: PropMap[];
  generic: PropMap[];
};

export const getRatParamsMap = (ratParamValues: RatObject): RatParamsMap => {
  const ratParamsMap = JSON.parse(JSON.stringify(ratPropsToParams));
  for (const [key, paramObj] of Object.entries(ratParamValues)) {
    for (const [id, value] of Object.entries(paramObj)) {
      ratParamsMap[key].unshift({
        prop: '',
        id,
        value,
      });
    }
  }

  return ratParamsMap;
};

export const generateParamString = (paramObj: PropMap[], props: RatProps) => {
  return paramObj
    .map((param: PropMap) => {
      const paramValue = param.value ? param.value : props[param.prop];
      return props[param.prop] || param.value
        ? `'${param.id}':` + (typeof paramValue === 'string' ? `'${paramValue}'` : paramValue)
        : null;
    })
    .filter((params) => params)
    .join(',');
};
